module.exports = __webpack_public_path__ + "5bfcfb4ecdd7d1566ccd75291549d21d.svg";